<div class="search-container-details">
    <div class="tab-title-icon">
        <cll-icon class="tab-icon" type="outlined">person</cll-icon>
        <div class="accordion-sub-title-accordion">
            <span class="detail-table-title">Users</span>
            <span class="detail-table-sub-title">Users associated with this commissioner</span>
        </div>
    </div>
    @if ((user()?.permissions?.permissions ?? []).includes('commissioner.update')) {
        @if (userSearchShown) {
            @if (commissionerData?.result$ | async; as result) {
                @if (users$ | async; as users) {
                    <div [formGroup]="userControl" class="w-full grid-columns-2 m-l-10">
                        <app-filtered-select
                            [label]="'Pick a user'"
                            [selected]="selectedUsers()"
                            [results]="users"
                            (selectedItemEvent)="selectedUser($event)"
                        />
                        <cll-form-field [label]="'Select a role'">
                            <select formControlName="role" cllFormInput>
                                <option value="Commissioner Admin">Commissioner admin</option>
                                <option value="Commissioner User">Commissioner user</option>
                            </select>
                        </cll-form-field>
                    </div>

                }
            }
        }

        @if (this.commissionerData?.result$ | async; as commissioner) {
            @if (commissioner.value?.data?.status) {
                <div class="flex-shrink-0">
                    <button
                        cll-icon-button
                        cllTooltip="Search users"
                        cllSuffix
                        (click)="toggleUserDropDown()">
                        <cll-icon>search</cll-icon>
                    </button>
                    <button
                        cll-icon-button
                        cllSuffix
                        [disabled]="!userControl.valid"
                        (click)="addUser()"
                    >
                        <cll-icon>add</cll-icon>
                    </button>
                </div>
            }
        }
    }
</div>

<div class="tabs-table-container">
    <table class="cll-table">
        <thead>
        <tr>
            <th>Users name</th>
            <th>Position</th>
            <th>Email</th>
            <th>Telephone number</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
            @if (this.commissionerData?.result$ | async; as commissioner) {
                @if ((commissioner.value?.data?.users ?? []).length > 0) {
                    @for (commissionerUser of commissioner.value?.data?.users; track commissionerUser.id) {
                        <tr>
                            <td>{{ getDisplayName(commissionerUser.user.person) }}</td>
                            <td>
                                @if (commissionerUser.user.permissions) {
                                    {{ commissionerUser.user.permissions.permission_name }}
                                }
                            </td>
                            <td>{{ commissionerUser.user.email }}</td>
                            <td>
                                @if (commissionerUser.user.contact_numbers[0]) {
                                    {{ commissionerUser.user.contact_numbers[0].number }}
                                }
                            </td>
                            <td class="align-right">
                                <button cll-icon-button
                                        [cllMenuTriggerFor]="menu"
                                        (click)="$event.stopPropagation()">
                                    <cll-icon>more_vert</cll-icon>
                                </button>

                                <ng-template #menu>
                                    <cll-menu>
                                        @if ((user()?.permissions?.permissions ?? []).includes('commissioner.update')) {
                                            <button cllMenuItem
                                                    (click)="editUserPosition(commissionerUser)">
                                                <cll-icon type="outlined">edit</cll-icon>
                                                Edit position
                                            </button>
                                        }
                                        <a cllMenuItem
                                           [routerLink]="['/users/', commissionerUser.user.id]">
                                            <cll-icon>open_in_new</cll-icon>

                                            View user
                                        </a>
                                        @if ((user()?.permissions?.permissions ?? []).includes('commissioner.update')) {
                                            <button cllMenuItem
                                                    (click)="removeUser(commissionerUser.user.id)">
                                                <cll-icon type="outlined">delete</cll-icon>
                                                Remove
                                            </button>
                                        }
                                    </cll-menu>
                                </ng-template>
                            </td>
                        </tr>
                    }
                } @else {
                    <tr>
                        <td colspan="5" class="no-data-row">
                            <div class="no-data-wrapper-tabs">
                                No users found.
                            </div>
                        </td>
                    </tr>
                }
            }
        </tbody>
    </table>
</div>
